import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  inject,
} from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxFormControlModule,
  FlxModalData,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import { FlxAutofocusDirective } from '@flowx/designer/shared/directives/autofocus.directive'
import { EnterSubmitFormDirective } from '@flowx/designer/shared/directives/enter-submit-form.directive'
import { JAVA_INT_MAX_VALUE, OnlyDigits } from '@flowx/designer/shared/entities/utils'
import { ToastMessageService } from '@flowx/designer/shared/services/toast-message.service'

@Component({
  selector: 'flx-tag-build-modal',
  templateUrl: './tag-build-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FlxModalModule,
    FlxFormControlModule,
    FormsModule,
    ReactiveFormsModule,
    FlxButtonModule,
    FlxAutofocusDirective,
    EnterSubmitFormDirective,
  ],
})
export class FlxTagBuildModalComponent implements OnInit {
  #data: FlxModalData = inject(FLX_MODAL_DATA)
  #modalService = inject(FlxModalService)
  #toastMessageService = inject(ToastMessageService)
  @Output() dataEventEmitter = new EventEmitter<any>()
  appTitleFG = new FormControl<string>({ value: '', disabled: true }, [])
  tagBuildFG = new FormGroup({
    major: new FormControl<number>(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(JAVA_INT_MAX_VALUE),
      Validators.pattern(OnlyDigits),
    ]),
    minor: new FormControl<number>(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(JAVA_INT_MAX_VALUE),
      Validators.pattern(OnlyDigits),
    ]),
    patch: new FormControl<number>(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(JAVA_INT_MAX_VALUE),
      Validators.pattern(OnlyDigits),
    ]),
  })
  title = 'Create build'
  subtitle = 'Set up a build tag:'
  ngOnInit(): void {
    this.appTitleFG.setValue(this.#data.appName)
  }

  get disableSubmitButton(): boolean {
    return this.tagBuildFG.invalid || this.tagBuildFG.pristine
  }
  get majorFc(): FormControl {
    return this.tagBuildFG.controls.major as FormControl
  }

  get minorFc(): FormControl {
    return this.tagBuildFG.controls.minor as FormControl
  }

  get patchFc(): FormControl {
    return this.tagBuildFG.controls.patch as FormControl
  }

  tagBuild(): void {
    if (this.tagBuildFG.valid) {
      const { major, minor, patch } = this.tagBuildFG.value
      if (major === 0 && minor === 0 && patch === 0) {
        this.#toastMessageService.showErrorMessage('Tag can not be 0.0.0')
      } else {
        this.dataEventEmitter.emit({
          major,
          minor,
          patch,
        })
      }
    }
  }

  closeModal(): void {
    this.#modalService.hide()
  }
}
